export const state = function () {
  return {
    isEditing: false,
  }
}

export const mutations = {
  SET_IS_EDITING(state, payload) {
    state.isEditing = payload
  },
}

export const actions = {
  RESET: function ({ dispatch }) {
    dispatch("legal_data/RESET")
    dispatch("natural_user/RESET")
  },
  FETCH: async function ({ dispatch }) {
    return Promise.all([
      dispatch("legal_data/FETCH"),
      dispatch("natural_user/FETCH"),
    ])
  },
  SET: function ({ commit }, billingInfos) {
    commit("natural_user/SET", billingInfos.natural_user)
    commit("legal_data/SET", billingInfos.legal_data)
  },
  UPDATE_ON_SERVER: function ({ dispatch }, billingInfos) {
    return Promise.all([
      dispatch("natural_user/UPDATE_ON_SERVER", billingInfos.natural_user),
      dispatch("legal_data/UPDATE_ON_SERVER", billingInfos.legal_data),
    ])
  },
}

export const getters = {
  IS_COMPLETE: function (state) {
    return state.natural_user.id > 0 && state.legal_data.id > 0
  },
}
